import React from "react";
import TabbedProjects from "../TabbedProjects";

const Projects = () => {
  return <TabbedProjects />;
};

export default Projects;